export const serviceOpsInvoicingConstants = {
    UPDATE_INVOICING_TABLE: 'SERVICEOPS_UPDATE_INVOICING_TABLE',
    UPDATE_INVOICING_TABLE_AFTER_SAVE: 'SERVICEOPS_UPDATE_INVOICING_TABLE_AFTER_SAVE',
    UPDATE_INVOICING_CARRIER_VALUE: 'SERVICEOPS_UPDATE_INVOICING_CARRIER_VALUE',
    SET_DATA_FROM_EXCEL: 'SERVICEOPS_SET_DATA_FROM_EXCEL',
    UPDATE_INVOICING_ROW_VALUE: 'SERVICEOPS_UPDATE_INVOICING_ROW_VALUE',
    LOADING: 'SERVICEOPS_LOADING',
    ERROR: 'SERVICEOPS_ERROR',
}